export type BrandFlags = {
  isHarbour: boolean;
  isBiz4Biz: boolean;
  isBiz: boolean;
};

export function detectBrandFromURL(): BrandFlags {
  const params = new URL(window.location.href).searchParams;
  const viaParam = params.get("via");

  if (viaParam === "harbour") {
    localStorage.setItem("isHarbourClub", "true");
    localStorage.setItem("isBiz4Biz", "false");
  } else if (viaParam === "biz4biz") {
    localStorage.setItem("isHarbourClub", "false");
    localStorage.setItem("isBiz4Biz", "true");
  } else {
    localStorage.setItem("isHarbourClub", "false");
    localStorage.setItem("isBiz4Biz", "false");
  }

  const isHarbour = localStorage.getItem("isHarbourClub") === "true";
  const isBiz4Biz = localStorage.getItem("isBiz4Biz") === "true";
  const isBiz = !isHarbour && !isBiz4Biz;

  return { isHarbour, isBiz4Biz, isBiz };
}
